import { useState } from 'react'

type Props = {
    name?: string
}

export default function PatientNameCell({ name }: Props) {
    const [showFull, setShowFull] = useState(false)

    if (!name) return <td>-</td>

    const words = name.split(' ')
    const isLong = words.length > 3
    const displayName = showFull || !isLong ? name : words.slice(0, 3).join(' ')

    return (
        <td
            className={isLong ? 'cursor-pointer select-none text-gray-800' : ''}
            onClick={() => isLong && setShowFull(!showFull)}
            title={name}
        >
            {displayName}{' '}
            {isLong && (
                <span className="text-primary hover:underline ml-1">
                    {showFull ? 'Show less' : 'Read more'}
                </span>
            )}
        </td>
    )
}
